import moment from 'moment-timezone';

export const forceTimezone = (timezone, dt) =>
  moment.tz(dt.format('YYYY-MM-DDTHH:mm:ss'), timezone);

// Creates a new moment with the date fields from date and the time fields from time.
// Make sure they are all local because moment initialize as local if there is no timezone.
export const combineDateTime = (date, time, timezone) => {
  const localDate = timezone ? forceTimezone(timezone, date) : date;
  const localTime = timezone ? forceTimezone(timezone, time) : time;
  return moment.tz([
    localDate.year(),
    localDate.month(),
    localDate.date(),
    localTime.hour(),
    localTime.minute(),
  ], timezone);
};



// WEBPACK FOOTER //
// ./src/common/utils/time.js